
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class TeachersInfo extends Vue {
  private curTab: any = 1;
  private tabsList: any = [
    {
      key: 1,
      value: "语文"
    },
    {
      key: 2,
      value: "数学"
    },
    {
      key: 3,
      value: "英语"
    }
  ];
  // 语文老师列表
  private chineseTeacherList: any = [
    // {
    //   name: "刘晓宇",
    //   number: "20201100142005284",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liuxiaoyu.png"
    // },
    {
      name: "王爽",
      number: "20141506042001437",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/wangshuang.png"
    },
    {
      name: "谢钰倩",
      number: "20174501522000920",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/xieyuqian.png"
    },
    {
      name: "姜欢",
      number: "20211110622002213",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/jianghuan.png"
    },
    {
      name: "张晓语",
      number: "20201110532000904",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhangxiaoyu.png"
    },
    {
      name: "夏梦",
      number: "20211110632000322",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/xiameng.png"
    },
    {
      name: "刘洪爽",
      number: "20211111122001258",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liuhongshuang.png"
    },
    {
      name: "沙微",
      number: "20072331621000439",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/shawei.png"
    },
    {
      name: "戴世超",
      number: "20071314131000508",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/daishichao.png"
    },
    // {
    //   name: "李嫄嫄",
    //   number: "20211100142009772",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liyuanyuan.png?t=20220810"
    // },
    // {
    //   name: "王鑫",
    //   number: "20175300242003798",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/wangxin.png?t=20220810"
    // },
    {
      name: "谭泊宁",
      number: "20211100141001728",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/tanboning.png"
    },
    // {
    //   name: "刘丹",
    //   number: "20194200242010474",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liudan.png"
    // },
    // {
    //   name: "石潇",
    //   number: "20051308941000330",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/shixiao.png"
    // },
    // {
    //   name: "刘舒",
    //   number: "20094115242001589",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liushu.png"
    // },
    {
      name: "靳明玥",
      number: "20171100142001862",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/jinmingyue.png"
    },
    {
      name: "宋丹丹",
      number: "20181340142009246",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/songdandan.png"
    },
    // {
    //   name: "岳雨卓",
    //   number: "20211110522002365",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/yueyuzhuo.png"
    // },
    {
      name: "王东东",
      number: "20192100521000740",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/wangdongdong.png"
    }
  ];
  // 数学老师列表
  private mathTeacherList: any = [
    {
      name: "高晓琳",
      number: "20191111022001279",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/gaoxiaolin.png"
    },
    {
      name: "张妍",
      number: "20183222122000447",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhangyan.png"
    },
    {
      name: "王梦楠",
      number: "20171310132003945",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/wangmengnan.png"
    },
    {
      name: "胡梦琳",
      number: "20211100142003228",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/humenglin.png"
    },
    {
      name: "张琬柔",
      number: "20172210052004698",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhangwanrou.png"
    },
    {
      name: "潘东旭",
      number: "20211110731000654",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/pandongxu.png"
    },
    {
      name: "纪娜",
      number: "20191110522000331",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/jina.png"
    },
    {
      name: "申东惠",
      number: "20144115242000107",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/shendonghui.png"
    },
    {
      name: "简雪娇",
      number: "20191110522000487",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/jianxuejiao.png"
    },
    {
      name: "赵欣",
      number: "20185312422000234",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhaoxin.png"
    },
    {
      name: "候世杰",
      number: "20191111021001226",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/houshijie.png"
    },
    {
      name: "穆小云",
      number: "20191110531001170",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/muxiaoyun.png"
    },
    {
      name: "于红韦",
      number: "20191110522002048",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/yuhongwei.png"
    },
    {
      name: "黄世胜",
      number: "20121310151003499",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/huangshisheng.png"
    },
    {
      name: "渠媛",
      number: "20191110622001622",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/quyuan.png"
    },
    {
      name: "张庆男",
      number: "20211110521002272",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhangqingnan.png"
    },
    {
      name: "赵晶",
      number: "20193701322000199",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhaojing.png"
    },
    {
      name: "刘润华",
      number: "20211221931001900",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liurunhua.png"
    },
    {
      name: "左志程",
      number: "20214109021000582",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zzc.png"
    },
    {
      name: "杜晨",
      number: "20211111422001018",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/duchen.png"
    },
  ];
  // 英语老师列表
  private englishTeacherList: any = [
    {
      name: "祁琪",
      number: "20211110622001705",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/qiqi.png"
    },
    {
      name: "张姝玉",
      number: "20191110722000395",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhangshuyu.png"
    },
    {
      name: "李美坪",
      number: "20173222142000232",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/limeiping.png"
    },
    {
      name: "刘露宸",
      number: "20174300842001511",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liuluchen.png"
    },
    {
      name: "王源钧",
      number: "20192100642000290",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/wangyuanjun.png"
    },
    {
      name: "纪洋洋",
      number: "20212121032000175",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/jiyangyang.png"
    },
    {
      name: "张琳",
      number: "20201110522000613",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/zhanglin.png"
    },
    {
      name: "刘杰",
      number: "20214113122001343",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/liujie.png"
    },
    {
      name: "李霜",
      number: "20181360132012045",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/lishuang.png"
    },
    // {
    //   name: "汤雪",
    //   number: "20154301342000527",
    //   avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/tangxue.png"
    // },
    {
      name: "王阿妮",
      number: "20211100142001821",
      avatar: "https://susuanqiniu.knowbox.cn/fe/www-m/wangani.png"
    }
  ];
  // 教师列表
  private teacherList: any = this.chineseTeacherList;
  private swicthTabs(item: any) {
    this.curTab = item.key;
    switch (item.key) {
      case 1:
        this.teacherList = this.chineseTeacherList;
        break;
      case 2:
        this.teacherList = this.mathTeacherList;
        break;
      case 3:
        this.teacherList = this.englishTeacherList;
        break;
    }
  }
}
